import type { IconSvgElement } from "@hugeicons/react";
import {
  DashboardSquare01Icon, Money03Icon, Briefcase01Icon, Building03Icon, Invoice01Icon, Wallet01Icon,
  UserGroupIcon, Calendar01Icon, Shield01Icon, Settings01Icon,
} from "@hugeicons/core-free-icons";

export interface NavItem {
  title: string;
  path: string;
  icon: IconSvgElement;
  roles: string[];
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const SECTIONS: NavSection[] = [
  {
    label: "Main Menu",
    items: [
      { title: "Overview", path: "/", icon: DashboardSquare01Icon, roles: ["admin", "manager", "user"] },
      { title: "Leads", path: "/sales/leads", icon: Money03Icon, roles: ["admin", "manager", "user"] },
      { title: "Projects", path: "/projects/all", icon: Briefcase01Icon, roles: ["admin", "manager", "user"] },
      { title: "Clients", path: "/clients", icon: Building03Icon, roles: ["admin", "manager", "user"] },
      { title: "Invoices", path: "/invoices", icon: Invoice01Icon, roles: ["admin", "manager", "user"] },
      { title: "Expenses", path: "/expenses", icon: Wallet01Icon, roles: ["admin", "manager", "user"] },
    ],
  },
  {
    label: "Tools",
    items: [
      { title: "Calendar", path: "/calendar", icon: Calendar01Icon, roles: ["admin", "manager", "user"] },
      { title: "Users", path: "/users", icon: UserGroupIcon, roles: ["admin"] },
      { title: "Audit Logs", path: "/audit-logs", icon: Shield01Icon, roles: ["admin"] },
    ],
  },
];

export const BOTTOM_ITEMS: NavItem[] = [
  { title: "Settings", path: "/settings", icon: Settings01Icon, roles: ["admin", "manager", "user"] },
];

export const NAV: NavItem[] = [...SECTIONS.flatMap((sec) => sec.items), ...BOTTOM_ITEMS];

export const isActiveRoute = (path: string, pathname: string) =>
  path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(path + "/");

export const getNavTitle = (pathname: string) =>
  NAV.find((n) => isActiveRoute(n.path, pathname))?.title || "Pelarhive";
